export default "__VITE_ASSET__C6hW0ZSq__"